<template>
  <div class="popup">
    <transition name="fade-in">
      <div
        ref="cover"
        class="mask"
        v-if="innerOpen"
        :style="coverStyle"
        @click="innerOpen = false"
        :class="panend ? 'pop-wrap-transition' : false"
      ></div>
    </transition>
    <transition name="slide-up" @after-leave="close">
      <div
        ref="section"
        v-if="innerOpen"
        class="select-box"
        :style="sectionStyle"
        :class="panend ? 'pop-wrap-transition' : false"
      >
        <div
          ref="header"
          class="select-box-title text-l"
          :class="$platformClass"
        >
          {{ title }}
          <!-- <Icon class="titleIcon" :type="type"></Icon> -->
          <label class="inputLabel" v-if="showSearch">
            <Icon class="searchIcon" type="searchType"></Icon>
            <input type="text" v-model="searchData" :placeholder="searchText" />
          </label>
        </div>
        <ul ref="selectBoxList" class="select-box-list">
          <ListItem
            :type="isQuestion ? 'quessionItem' : 'selectItem'"
            v-for="(item, i) in filterData"
            class="text"
            :beforeIconType="type + 'List'"
            leftSpan="30px"
            rightSpan="30px"
            afterIconType="selectList"
            :active="result === i || selectedIndex === i"
            @click="select(i, item)"
            :key="i"
          >
            {{ item }}
            <!-- <a href="javascript:;" class="select-box-list-item text" :class="{'selected':(result===i||selectedIndex===i)}" @click="select(i)">{{item}}</a> -->
          </ListItem>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import Hammer from 'hammerjs';
export default {
  name: 'select-box',
  props: [
    'open',
    'list',
    'title',
    'selectedIndex',
    'type',
    'showSearch',
    'searchText',
  ],
  data: () => {
    return {
      result: 0,
      innerOpen: false,
      panend: false,
      hammer: null,
      coverStyle: '',
      sectionStyle: '',
      searchData: '',
      isQuestion: false,
    };
  },
  methods: {
    close: function () {
      this.$refs.selectBoxList && (this.$refs.selectBoxList.scrollTop = 0);
      this.searchData = '';
      this.$emit('close');
    },
    select: function (i, item) {
      this.result = this.showSearch ? this.list.indexOf(item) : i;
      this.$emit('select', this.result);
      this.close();
    },
    // pan手势
    handlePanEvent() {
      let $header = this.$refs.header;
      let $section = this.$refs.section;
      let hammer = new Hammer($header);
      this.hammer = hammer;
      hammer.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
      hammer.on('pandown panup', ev => {
        if (ev.deltaY < 0) {
          const scrollUpY = ev.deltaY / 80;
          const scaleX = -ev.deltaY / 20000 + 1;
          this.sectionStyle = `transform: scale(${scaleX}) translateY(${scrollUpY}px)`;
          return;
        }

        const opacity = 1 - ev.deltaY / 1024;
        this.coverStyle = `opacity: ${opacity}`;

        const scrollY = ev.deltaY * 1.2;
        this.sectionStyle = `transform: translateY(${scrollY}px)`;
      });
      hammer.on('panstart', () => {
        this.panend = false;
      });
      hammer.on('panend', ev => {
        this.panend = true;
        this.$nextTick(() => {
          if (ev.deltaY > Math.floor($section.clientHeight / 3)) {
            this.coverStyle = 'opacity: 0';
            this.sectionStyle = 'transform: translateY(100%)';
            this.$nextTick(() => {
              this.innerOpen = false;
            });
          } else {
            this.coverStyle = 'opacity: 1';
            this.sectionStyle = 'transform: translateY(0)';
          }
        });
      });
    },
  },
  mounted: function () {
    let hanlerMap = new WeakMap();
    let el = this.$el;
    hanlerMap.set(el, e => {
      e.stopPropagation();
    });
    el.addEventListener('touchmove', hanlerMap.get(el));
  },
  watch: {
    type: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        this.isQuestion = newVal === 'quession' && this.$isOmni;
      },
    },
    open: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        this.innerOpen = newVal;
        if (newVal) {
          this.result = -1;
        }
      },
    },
    innerOpen: {
      immediate: true,
      handler(val) {
        if (val) {
          this.coverStyle = '';
          this.sectionStyle = '';
          this.$nextTick(() => {
            this.handlePanEvent();
          });
        } else {
          if (this.hammer) {
            this.hammer.destroy();
            this.hammer = null;
          }
        }
      },
    },
  },
  beforeDestroy() {
    if (this.hammer) {
      this.hammer.destroy();
      this.hammer = null;
    }
  },
  computed: {
    filterData() {
      if (this.searchData !== '' && this.showSearch) {
        return this.list.filter(
          item =>
            item.toLowerCase().indexOf(this.searchData.toLowerCase()) !== -1
        );
      }
      return this.list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.select-box-title {
  position: relative;
}

.titleIcon {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.popup {
  .select-box {
    width: 100%;
    max-height: 80vh;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;
    &-title {
      width: 100%;
      text-align: left;
      padding: 28px 30px 0;
    }
    &-list {
      margin-top: 25px;
      max-height: calc(80vh - (28px + 60px + 25px));
      min-height: 30vh;
      overflow-y: scroll;
      padding: 0 30px;
      &-item {
        display: block;
        width: 100%;
        height: 80px;
        line-height: 80px;
        padding-left: 77px;
        border: solid 1px #5fd193;
        margin-bottom: 10px;
      }
      li:last-child {
        margin-bottom: 30px;
      }
    }
    .selected {
      color: $green;
    }
  }
}
/*选择框过渡动画*/
.slideup-enter,
.slideup-leave-to {
  transform: translateY(352px);
}

.slideup-enter-active,
.slideup-leave-active {
  transition: all ease 0.6s;
}
.slideup-enter-to,
.slideup-leave {
  transform: translateY(0px);
}
/*遮罩层过渡动画*/

input {
  width: 100%;
  height: 62px;
  line-height: 62px;
  padding: 0 20px 0 70px;
  border: solid 1px #dfdfdf;
  color: #3b3b3b;
  font-size: 24px;
  border-radius: 14px;
}

.inputLabel {
  position: relative;
  display: block;
  float: right;
  width: 70%;
  height: 62px;
  line-height: 62px;
}

.searchIcon {
  position: absolute;
  left: 30px;
  top: 55%;
  transform: translateY(-50%);
}

input:focus {
  outline: none;
}
</style>
